// Inspired by jQuery show and hide
// https://github.com/jquery/jquery/blob/e743cbd28553267f955f71ea7248377915613fd9/src/css/showHide.js

let defaultDisplayMap = {}

function getDefaultDisplay(elem) {
  let temp,
    doc = elem.ownerDocument,
    nodeName = elem.nodeName,
    display = defaultDisplayMap[nodeName]

  if (display)
    return display

  temp = doc.body.appendChild(doc.createElement(nodeName))
  display = window.getComputedStyle(temp).display

  temp.parentNode.removeChild(temp)
  if (display === 'none') {
    display = 'block'
  }
  defaultDisplayMap[nodeName] = display

  return display
}

function showHide(elem, show, defaultDisplay = null) {
  if (!elem.style) return elem

  const display = getDisplay(elem)
  if (show) {
    // Show elem
    if (display === 'none') {
      // Current elem is hidden
      const old = elem.getAttribute('data-prev-display') || null

      if (!old) {
        elem.style.display = ''
      } else {
        elem.style.display = old
      }
    }

    if (elem.style.display == '' && display === 'none') {
      elem.style.display = defaultDisplay || getDefaultDisplay(elem)
    }
  } else {
    // Hide elem
    if (display !== 'none') {
      // Current elem is displayed
      elem.setAttribute('data-prev-display', display)
      elem.style.display = 'none'
    }
  }

  return elem
}

function getDisplay(elem) {
  return window.getComputedStyle(elem, null).getPropertyValue('display')
}

export function show(elem) {
  return showHide(elem, true)
}

export function hide(elem) {
  return showHide(elem, false)
}

// Use the proposed solution from the link below
// Won't work with fixed elements, but is blazing fast
//
// https://stackoverflow.com/a/21696585
export function isHidden(elem) {
  return elem.offsetParent === null
}

export function isVisible(elem) {
  return !isHidden(elem)
}

export function toggle(elem, show = null, defaultDisplay = null) {
  if (typeof show !== 'boolean') {
    show = isHidden(elem)
  }

  return showHide(elem, show, defaultDisplay)
}
